// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3aIKS","header":"PatientQuestionnaire_header__38Fww","info":"PatientQuestionnaire_info__1j8W8"};